var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"title":"Get Cloud!","href":"https://www.prefect.io/get-prefect#pricing","target":"_blank"}},[(!_vm.isCloud)?_c('v-icon',{staticClass:"mr-2",attrs:{"dense":""}},[_vm._v(" cloud ")]):_vm._e(),_vm._v(" Get Cloud ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }